module.exports = __webpack_public_path__ + "img/youtube.8acabbd2.png";